module.exports = "/_next/static/media/ccff2ac18ba76abbc5d8c6defba15e7c.svg";